<div [attr.data-cy]="dataCy" (click)="onClick()" iesIconButton class="remove-button">
  <span class="label-icon">
    <span class="material-icons remove-icon md-inactive" aria-hidden="true"> highlight_off </span>
  </span>
  <div class="remove-text" [attr.aria-label]="label">{{ label }}</div>
</div>
